import { FirestoreDatabase as Database } from "../../db/common";
import { NEWS_COLLECTION, NEWS_COMMENTS_COLLECTION, NewsStoryComment } from "../../db/news";
import { BaseFirestoreServiceWithTimestamp } from "../FirestoreService";


/**
 * Shared News Comments Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class NewsCommentsService extends BaseFirestoreServiceWithTimestamp<NewsStoryComment> {
    constructor(protected db: Database, protected newsId: string) {
        super(db);
    }
    protected getCollectionPath(): string {
        return `${NEWS_COLLECTION}/${this.newsId}/${NEWS_COMMENTS_COLLECTION}`;
    }
}